<template>
  <div class="container report">
    <div class="searchCondition" v-show="false">
      <span class="utc">UTC-0</span>
      <el-date-picker
        v-model="where.date"
        type="monthrange"
        :clearable="false"
        start-placeholder="from"
        end-placeholder="to"
        value-format="yyyy-MM"
         size="mini"
      >
      </el-date-picker>
      <el-button  size="mini" @click="search">Search</el-button>
      <exportcsv :rows="rows" filename="Billing" :tableObj="$refs.table"></exportcsv>
      
      <span class="notice"
        >Please sign and stamp on the invoice, or the payment will not be
        released !
      </span>
      <!-- <div class="tip"><span style="font-size">Revenue Total:</span> ${{ revenueTotal }}</div> -->
    </div>
    <el-table
      :data="rows"
      height="250"
      border
      stripe
      class="table"
      v-loading="loading"
      header-row-class-name="table-header"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      ref='table'
    >
      <el-table-column prop="time" label="Month" width="180">
        <span slot-scope="sp">
          {{getBillingTime(sp.row.time)}}
        </span>
      </el-table-column>
      <el-table-column prop="aff_id" label="Pub Id" width="120"> </el-table-column>

      <el-table-column prop="aff_name" label="Publisher" width="180">
      </el-table-column>
      <!-- <el-table-column prop="rev" label="Revenue($)" width="180">
      </el-table-column> -->
      <el-table-column prop="final_rev" label="Final Revenue($)">
      </el-table-column>
      <el-table-column prop="invoice_file" label="Invoice">
        <file-upload
          slot-scope="sp"
          v-model="sp.row.invoice_file"
          :afterChange="
            () => {
              afterChange(sp.row);
            }
          "
          dir="pubInvoice"
        ></file-upload>
      </el-table-column>

      <el-table-column prop="status" label="Status">
        <span slot-scope="sp" :class="'status-' + sp.row.status.trim()">{{
          sp.row.status.toUpperCase()
        }}</span>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-left: 30px"
      layout="total,sizes,prev, pager, next"
      :total="total"
      :current-page.sync="page"
      @current-change="search"
      :page-size.sync="limit"
      @size-change="search"
      :page-sizes="[10,50,100]"

    >
    </el-pagination>
  </div>
</template>
<script>
import { post } from "@/lib/channelClient";
import fileUpload from "@/components/channelClient/fileUpload.vue";
import exportcsv from '@/components/channelClient/exportcsv.vue';

const current = new Date();
current.setMonth(current.getMonth() - 1);
const currentMonth = current.toISOString().substr(0, 7);
export default {
	components: {
		"file-upload": fileUpload,
		exportcsv,
	},
	data() {
		return {
			where: {
				date: [currentMonth, currentMonth],
			},
			rows: [],
			total: 0,
			limit: 10,
			page: 1,
			revenueTotal: 0,
			loading: false,
		};
	},
	mounted() {
		this.search();
	},
	methods: {
		async search() {
			await new Promise((res) => setTimeout(res, 0));
			// const where = this.where;
      const where = {};
			const limit = this.limit;
			const offset = (this.page - 1) * limit;
			this.loading = true;
			const res = await post("/channelClient/billing", {
				where,
				limit,
				offset,
			});
			this.loading = false;
			if (res.status != 200) {
				const text = await res.text();
				if (/login/.test(text)) {
					window.location.href = "/login";
					return;
				}
				this.$message.error({ message: text, duration: 1500 });
				return;
			}
			const body = await res.json();
			this.rows = body.rows;
			this.total = body.count;
		},
    async afterChange(row) {
			await post("/channelClient/billingUpdate", {
				id: row.id,
				invoice_file: row.invoice_file,
			});
		},
    getBillingTime(time) {
      const date = new Date(time);
      const year = date.getUTCFullYear();
      const month = date.getUTCMonth();
      const en = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
      const en_month = en[month];
      return en_month + '-' + year;
    }

	},
};
</script>
<style scoped>
.notice {
  margin-left: 40px;
  font-size: 16px;
  color:red;
}


</style>
